// src/components/LandingSection.js
import React from "react";
import CircularProgress from "../components/CircularProgress";
import Timer from "../components/Timer";
import TypeWriterText from "../components/TypeWriterText";
import Badge from "../components/Badge";
import ProfileAvatar from "../components/ProfileAvatar";
import "./contentpage.css";

function LandingSection({
  titleText,
  scrollToRef,
  progressValue = 0,
  timerMinutes = 25,
  currentLevel = 0, // 👈 level 0–6
  unlockedBadges = 0, // 👈 number of unlocked badges (1–8)
}) {
  const handleArrowClick = () => {
    if (scrollToRef && scrollToRef.current) {
      scrollToRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const levels = [1, 2, 3, 4, 5, 6,7,8];

  return (
    <div className="landing-container">
      {/* --- LEVEL DISPLAY --- */}
      <div className="level-display">
        <span className="level-label">Level</span>
        {levels.map((level) => (
          <span
            key={level}
            className={`level-number ${
              level === currentLevel ? "active-level" : "inactive-level"
            }`}
          >
            {level}
          </span>
        ))}
      </div>

      {/* --- BADGE + AVATAR ROW --- */}
      <div
        className="top-badge-row"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "20px",
          marginBottom: "20px",
        }}
      >
        {/* 👇 Badge on the left, avatar on the right */}
        <Badge unlockedCount={unlockedBadges} />
        <ProfileAvatar />
      </div>

      {/* --- PROGRESS + TIMER --- */}
      <div className="landing-row">
        <div className="progress-section">
          <CircularProgress value={progressValue} />
        </div>
        <div className="timer-section">
          <Timer initialMinutes={timerMinutes} />
        </div>
      </div>

      {/* --- TYPEWRITER TEXT --- */}
      <div className="typewriter-section">
        <TypeWriterText text={titleText} delay={80} />
      </div>

      {/* --- BOUNCING ARROW --- */}
      <div
        className="bounce-indicator"
        onClick={handleArrowClick}
        style={{ cursor: "pointer" }}
      ></div>
    </div>
  );
}

export default LandingSection;
